import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../features';
import { actions, ReactionPostErrorType } from '../../features/reaction';
import { throttle } from '../../lib/utils';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';
import { Dialog } from '../shared/dialog/Dialog';

export const ReactionErrorDialog: React.FC = () => {
  const { t } = useTranslation(['reaction', 'translation']);
  const history = useHistory();
  const dispatch = useDispatch();
  const { sendStatus } = useSelector((state: RootState) => state.reaction);

  useEffect(() => {
    return () => {
      dispatch(actions.clearPostError());
    };
  }, [dispatch]);

  const handleCloseClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [history]
  );

  if (sendStatus?.state !== 'error') {
    return <></>;
  }

  const errorDesc = getReactionError(t, sendStatus.error);

  return (
    <Dialog title={t('error_send_failed')}>
      <>
        <p
          className={css`
            flex: 1 1 auto;
            display: flex;
            padding: 12px 0 32px;
          `}
        >
          {errorDesc}
        </p>

        <div
          className={css`
            flex: 0 0 auto;
            padding: 0 0 4px;
          `}
        >
          <ConfirmButton onClick={handleCloseClick}>
            {t('translation:dialog_button_ok')}
          </ConfirmButton>
        </div>
      </>
    </Dialog>
  );
};

// helper function
function getReactionError(t: TFunction, errorType: ReactionPostErrorType) {
  switch (errorType) {
    case 'im-offline':
      return t('error_im_offline');
    case 'rate-limit-exceeded':
      return t('translation:error_rate_limit_exceeded');
    case 'unstable-network':
      return t('translation:error_unstable_network');
    case 'unknown':
    default:
      return t('translation:error_unknown');
  }
}
